
































import {mixins}    from 'vue-class-component';
import {Component} from 'vue-property-decorator';
import MainMixin   from '@/mixins/Main';

@Component({
    name: `Logo`
})
export default class Logo extends mixins(MainMixin)
{
}
